import { render, staticRenderFns } from "./MetaButtonsDisplay.vue?vue&type=template&id=52cbb92a&scoped=true"
import script from "./MetaButtonsDisplay.vue?vue&type=script&lang=js"
export * from "./MetaButtonsDisplay.vue?vue&type=script&lang=js"
import style0 from "./MetaButtonsDisplay.vue?vue&type=style&index=0&id=52cbb92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cbb92a",
  null
  
)

export default component.exports